import { GridColumn } from 'src/components/GridWrapper';
import DeleteItem from 'src/sections/invoice_details/split_line_item/DeleteItem';
import {
  AmountFooterCell,
  GLFooterCell,
} from 'src/sections/invoice_details/split_line_item/FooterCell';
import InfoCell from 'src/sections/invoice_details/split_line_item/InfoCell';
import SplitAmount from 'src/sections/invoice_details/split_line_item/SplitAmount';
import SplitGlCode from 'src/sections/invoice_details/split_line_item/SplitGlCode';

export const SplitLineItemColumns: GridColumn<any>[] = [
  {
    field: 'errors',
    title: '',
    component: InfoCell,
    width: 60,
    menu: false,
  },
  {
    field: 'glCd',
    title: 'GL Code',
    menu: false,
    component: SplitGlCode,
    footerCell: GLFooterCell,
    width: 340,
    dataType: 'dollar',
  },
  {
    field: 'quantityReceived',
    title: 'Amount',
    menu: false,
    component: SplitAmount,
    footerCell: AmountFooterCell,
    width: 150,
    dataType: 'fixed',
  },
  {
    field: 'delete',
    title: '',
    component: DeleteItem,
    menu: false,
  },
];
